import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  :root {
    --red: #FF4949;
    --black: #2E2E2E;
    --yellow: #ffc600;
    --white: #fff;
    --grey: #efefef;
  }
  
   *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
   html {
    font-size: 62.5%;
  }
  
  body {
    padding: 0;
    margin: 0;
    font-size: 1.6rem;
  }
  
  *, input, select, textarea, option, button {
    outline: none!important;
  }
  
  .gatsby-image-wrapper img[src*=base64\\,] {
    image-rendering: -moz-crisp-edges;
    image-rendering: pixelated;
  }

  img {
    max-width: 100%;
  }
  
  
.alert-error {
  background-color: #f2d7d5;
  border-left-color: #c0392b;
  color: #c0392b;
}

.alert-success {
  background-color: #d5f5e3;
  border-left-color: #2ecc71;
  color: #2ecc71;
}

.alert {
  display: block;
  padding: 20px;
  border-left: 5px solid;
}

`;

export default GlobalStyles;
